import { DrawingEdge, DrawingShape } from '~/core/models';
import {
  ensureMutableArray,
  forceAssignArrayElement,
  forceAssignProperty,
} from '~/core/utils/objectMutability.utils';

export const replaceEdgeInShape = (
  shape: DrawingShape,
  originalEdge: DrawingEdge,
  mutableEdge: DrawingEdge
): void => {
  if (mutableEdge === originalEdge) {
    return;
  }

  const mutableArray = ensureMutableArray(shape.drawingEdges);

  if (mutableArray !== shape.drawingEdges) {
    forceAssignProperty(shape, 'drawingEdges', mutableArray);
  }

  const edgeIndexInArray = mutableArray.findIndex(
    (e) => e.id === originalEdge.id
  );

  if (edgeIndexInArray !== -1) {
    const assigned = forceAssignArrayElement(
      mutableArray,
      edgeIndexInArray,
      mutableEdge
    );

    if (!assigned) {
      console.warn('Failed to replace edge in drawingEdges array');
    }
  } else {
    console.warn('Could not find edge in shape.drawingEdges array to replace');
  }
};
